import { MediaLayer } from "./MediaLayer";
import type { FullBleedMediaData } from "./schemas";

export default function FullBleedMedia(props: FullBleedMediaData) {
  const pos = props.text_position ?? "bottom";
  const align =
    pos === "center"
      ? "items-center justify-center text-center"
      : pos === "top"
        ? "items-start justify-start pt-[18%]"
        : "items-start justify-end pb-[16%]";
  return (
    <section className="relative w-full overflow-hidden vignette" style={{ minHeight: "92svh" }}>
      <MediaLayer media={props.media} alt={props.title || "media"} />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      <div className={`absolute inset-0 px-7 z-10 flex flex-col ${align}`}>
        {props.kicker && (
          <div className="text-[10px] tracking-[0.4em] uppercase text-gold/90 mb-3 text-shadow-soft">
            {props.kicker}
          </div>
        )}
        {props.title && (
          <h2 className="font-serif text-4xl leading-[1.05] text-foreground text-shadow-soft max-w-[14ch]">
            {props.title}
          </h2>
        )}
        {props.caption && (
          <p className="mt-3 text-sm text-foreground/85 font-light max-w-[36ch] text-shadow-soft">
            {props.caption}
          </p>
        )}
      </div>
    </section>
  );
}
